export const COMPLEXITY = {
  1: "Low Complexity",
  2: "Medium Complexity",
  3: "High Complexity",
};

export const COMPLEXITY_CONTRACTION = {
  1: "Low",
  2: "Mid",
  3: "High",
};

export const COMPLEXITY_COLORS = {
  1: "#383131",
  2: "#383131",
  3: "#383131",
};

export const COMPLEXITY_BGC = {
  1: "powderblue",
  2: "#fff8e1",
  3: "#e8c8e5",
};

export const OpenAPISpec =
  "This guide provides a comprehensive overview of the migration process, including the necessary steps and file configurations.";
